<template>
	<div id="app" class="">
    <router-view></router-view>
	</div>
</template>

<script>
export default {

	name: 'App',
	data() {
		return {
			localUrl: window.location.href,
			recordNum: 17125925, //备案号
		}
	},
	created() {
	}
}
</script>

<style>
@import "assets/css/bootstrap.css";
@import "assets/css/style.css";

#app {
	width: 100%;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue